<template>
  <div>
    <div class="text-[14px] text-white my-2">{{ label }}</div>
    <div
      class="flex items-center bg-[#2C7952]/30 rounded-lg focus-within:bg-[#2C7952]/70 relative"
    >
      <Image :src="icon" class="w-6 h-6 mx-2 !absolute left-2" />
      <input
        :placeholder="placeholder"
        v-model="inputValue"
        class="text-white flex-1 !text-[15px] h-[44px] bg-[#2C7952]/40 border-none outline-none pl-14 rounded-[8px]"
        @input="handleInput"
        :type="inputType"
      />
    </div>
    <div
      v-if="errorMessage"
      class="bg-[#2C7952] text-white rounded flex items-start justify-center text-[12px] py-2 text-center"
    >
      {{ errorMessage }}
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  label: String,
  placeholder: String,
  modelValue: String,
  icon: String,
  errorMessage: {
    type: String,
    default: "",
  },
  inputType: {
    type: String,
    default: "text",
  },
});

const emit = defineEmits(["update:modelValue", "input"]);

const inputValue = ref(props.modelValue);

watch(
  () => props.modelValue,
  (newValue) => {
    // 如果输入的是CPF，则只允许输入数字
    if (props.label && props.label.indexOf("CPF") > -1) {
      inputValue.value = newValue?.replace(/[^0-9]/g, "");
    } else {
      inputValue.value = newValue;
    }
  }
);

const handleInput = (e) => {
  let value = e.target.value;
  // 如果输入的是CPF，则只允许输入数字
  if (props.label && props.label.indexOf("CPF") > -1) {
    value = value.replace(/[^0-9]/g, "");
  }
  inputValue.value = value;
  emit("update:modelValue", value);
  emit("input", e);
};
</script>
